import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { OrderProvider } from './context/OrderContext';
import SimpleOrderPage from './components/SimpleOrderPage';
import PriceConfigPage from './components/PriceConfigPage';
import LoginPage from './components/LoginPage';
import AdminPage from './components/AdminPage';
import './App.css';

const AppContent = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="App">Cargando...</div>;
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <OrderProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="App">
          <Routes>
            <Route path="/" element={<SimpleOrderPage />} />
            <Route path="/config" element={<PriceConfigPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </div>
      </Router>
    </OrderProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
